import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import callFileProviderAPI from '../../utils/callFileProviderAPI';
import FileProviderServiceResponse from '../../types/FileProviderServiceResponse';
import OneDriveItem from '../../types/OneDriveItem';
import { API_BASE_FOR_ID, ROOT_FOLDER_ID } from './constants';
import { getAllColumnNames } from './columns';

export async function createOneDriveFolder(
    providerType: AttachmentDataProviderType.OneDriveConsumer,
    apiBaseUrl: 'https://s2s-api.onedrive.com',
    folderName: string,
    parentFolderId?: string
): Promise<FileProviderServiceResponse<OneDriveItem>>;
export async function createOneDriveFolder(
    providerType: AttachmentDataProviderType.OneDrivePro,
    apiBaseUrl: string,
    folderName: string,
    parentFolderId?: string
): Promise<FileProviderServiceResponse<OneDriveItem>>;
export async function createOneDriveFolder(
    providerType:
        | AttachmentDataProviderType.OneDriveConsumer
        | AttachmentDataProviderType.OneDrivePro,
    apiBaseUrl: string,
    folderName: string,
    parentFolderId?: string
): Promise<FileProviderServiceResponse<OneDriveItem>> {
    parentFolderId = parentFolderId || ROOT_FOLDER_ID;

    const query = `expand=thumbnails(select=medium)&select=${getAllColumnNames()}`;
    const url = `${apiBaseUrl}/${API_BASE_FOR_ID}/${parentFolderId}/children?${query}`;
    const requestBody = {
        name: folderName,
        folder: {},
    };

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    const response = await callFileProviderAPI(url, providerType, {
        requestInit: {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: headers,
        },
    });

    if (response.ok) {
        const responseBody = await response.text();
        const createFolderResponse = JSON.parse(responseBody) as OneDriveItem;

        return { errorResponse: null, result: createFolderResponse };
    } else {
        return { errorResponse: response, result: null };
    }
}
